var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "position_cluster flex flex-col gap-[20px]"
  }, [_vm.loading ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "flex items-center gap-[5px]"
  }, [_c('Input', {
    attrs: {
      "suffix": "ios-search",
      "title": _vm._searchPlaceholder,
      "placeholder": _vm._searchPlaceholder,
      "clearable": ""
    },
    on: {
      "on-change": _vm.onChangeSearch
    },
    model: {
      value: _vm.searchValue,
      callback: function ($$v) {
        _vm.searchValue = $$v;
      },
      expression: "searchValue"
    }
  }), _vm.isAdmin ? _c('div', {
    staticClass: "w-[32px] h-[32px] border-[1px] border-solid border-[#e7e7e7] rounded-[4px] flex items-center justify-center box-border flex-shrink-0"
  }, [_c('Icon', {
    staticClass: "cursor-pointer",
    attrs: {
      "size": 20,
      "type": "md-add"
    },
    on: {
      "click": _vm.onAdd
    }
  })], 1) : _vm._e()], 1), _c('div', {
    staticClass: "position_cluster_content"
  }, [_vm._l(_vm.list, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "item flex items-center justify-between",
      class: {
        item_active: item.id === _vm.checkeditem.id
      },
      attrs: {
        "title": item.tagName
      },
      on: {
        "click": function ($event) {
          return _vm.onChange(item);
        }
      }
    }, [_c('div', {
      staticClass: "text text-ellipsis px-2"
    }, [_vm._v(_vm._s(item.tagName))]), _vm.isAdmin ? _c('Dropdown', {
      staticClass: "more_icon",
      attrs: {
        "transfer": "",
        "placement": "bottom"
      }
    }, [_c('Icon', {
      attrs: {
        "size": 20,
        "type": "md-more"
      }
    }), _c('DropdownMenu', {
      staticClass: "p-2",
      attrs: {
        "slot": "list"
      },
      slot: "list"
    }, [_c('DropdownItem', {
      nativeOn: {
        "click": function ($event) {
          return _vm.onEdit(item);
        }
      }
    }, [_vm._v(` ${$t("e5fv2", "修改")} `)]), _c('DropdownItem', {
      nativeOn: {
        "click": function ($event) {
          return _vm.onDetail(item);
        }
      }
    }, [_vm._v(` ${$t("obrz2", "详情")} `)]), _c('DropdownItem', {
      nativeOn: {
        "click": function ($event) {
          return _vm.onDelete(item);
        }
      }
    }, [_vm._v(` ${$t("eslg2", "删除")} `)])], 1)], 1) : _vm._e()], 1);
  }), _vm.list.length === 0 ? _c('div', {
    staticClass: "text-center"
  }, [_vm._v($t("dctj1w4", "暂无岗位"))]) : _vm._e()], 2), _c('PositionAdd', {
    attrs: {
      "row": _vm.position.row,
      "edit": _vm.position.edit
    },
    on: {
      "onSuccess": _vm.onSuccess
    },
    model: {
      value: _vm.position.visible,
      callback: function ($$v) {
        _vm.$set(_vm.position, "visible", $$v);
      },
      expression: "position.visible"
    }
  }), _c('PositionDetail', {
    attrs: {
      "row": _vm.positionDetail.row
    },
    model: {
      value: _vm.positionDetail.visible,
      callback: function ($$v) {
        _vm.$set(_vm.positionDetail, "visible", $$v);
      },
      expression: "positionDetail.visible"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };